const parseAnchor = (string = ''): string => string.split(' ').join('_');

export default parseAnchor;
